import React, { FC, Fragment } from 'react'
import CommonGrid from 'shared/commonGrid';
import { Spinner } from '@blueprintjs/core';
import { ROWSELECTION } from 'shared/commonGrid/grid-enums';
import { SelectionChangedEvent } from '@ag-grid-community/core';
import useFqdn from '../../hooks/useFqdn'
import { fqdnViewDomainDefs } from '../../fqdn.types'
import { FqdnViewHeader } from './FqdnViewHeader'

export const FqdnView:FC = () => {
  const { items, isLoading, selectedItem } = useFqdn()
  const rowData = items.filter(({ fsId: groupName }) => groupName === selectedItem?.fsId)

  return (
    <Fragment>
      <FqdnViewHeader />
      {isLoading && <Spinner aria-label="Loading..." />}
      {!isLoading && (
        <div data-testid="FqdnView" className="GridPageContainer" style={{ maxWidth: '700px' }}>
          <CommonGrid
            hideSearchBar
            pagination
            enableBrowserTooltips
            rowSelection={ROWSELECTION.SINGLE}
            rowData={rowData}
            noResults={false}
            isBeforeLogout={false}
            columnDefs={fqdnViewDomainDefs}
            onSelectionChanged={(event: SelectionChangedEvent) => event.api.deselectAll()}
          />
        </div>
      )}
    </Fragment>
  )
}

export default FqdnView
